<template>
    <div class="wgCalcHeader">
        <ul class="wgCalcHeader__steps">
            <li v-for=" step in steps" :key="'step_'+step.key" @click="onStepClick(step)" :class="{active:$storage.state.currentStep.key == step.key}" :style="{cursor: $storage.state.passed.indexOf(step.key)>=0 ? 'pointer' : 'default'}">
                <span>{{$t('steps.'+step.key)}}</span>
            </li>
        </ul>
        <div class="wgCalcHeader__price" v-if="wgCalc.showPrices">
<!--
            <div class="wgCalcHeader__price_item">
                <span class="amount">{{ $storage.state.invoice.greenDiscount ? formatNumber($storage.state.invoice.greenDiscount)  : '-'}} {{$t('cur_sign')}}</span>
                <span class="text">{{$t('heading.green_subsidy')}}</span>
            </div>
-->
            <div class="wgCalcHeader__price_item">
                <span class="amount">{{ $storage.state.invoice.total ? formatNumber($storage.state.invoice.total) : '-'}} {{$t('cur_sign')}}</span>
                <span class="text">{{$t('heading.total')}}</span>
            </div>

        </div>
    </div>
</template>
<script>
import { steps } from "../helpers";

export  default {
    name: 'CalcHeading',
    data(){
        return {
            steps: steps.filter(i=>undefined == i.skip)
        }
    },
    methods:{
        onStepClick(step){
            if(this.$storage.state.passed.indexOf(step.key)>=0){
                this.$storage.state.currentStep = step
            }
        },
        formatNumber(val){
            return new Intl.NumberFormat().format(val) ;
        }
    }
}
</script>
<style lang="scss">
.wgCalc{
    &Header{
        display: none;
        grid-template-columns: 1fr auto;
        width: 100%;
        box-shadow: rgb(0 0 0 / 10%) 0px 2px 20px;
        @media (min-width: 756px){
            display: grid;
        }
        &__steps{
            display: grid;
            grid-template-columns: repeat(5, auto);
            height: 72px;
            padding: 0px;
            margin: 0px;
            li{
                height: 100%;
                width: 100%;
                background-color: white;
                list-style: none;
                text-align: center;
                display: flex;
                -webkit-box-align: center;
                align-items: center;
                -webkit-box-pack: center;
                justify-content: center;
                font-size: 16px;
                cursor: pointer;
                transition: all 150ms ease 0s;
                span{
                    padding-bottom: 4px;
                    transition: all 250ms ease 0s;
                }
                &.active{
                    span{
                        border-bottom: 2px solid var(--solar-calc-primary-color);
                        font-weight: 600;
                        margin-top: 2px;
                        padding-bottom: 4px;
                    }
                }
            }
        }
        &__price{
            display: grid;
            min-width: 200px;
            gap: 1rem;
            //grid-template-columns: 1fr 1fr;
            grid-template-columns: 1fr;
            align-content: center;
            padding: 0.5rem 1.5rem;
            color: rgb(255, 255, 255);
            background: var(--solar-calc-primary-color-bg);;
            text-align: left;

            &_item{
                span{
                    display: block;
                    &.amount{
                        font-size: 20px;
                        font-weight: 300;
                        letter-spacing: 0.75px;
                        margin-bottom: 0.25rem;
                    }
                    &.text{
                        font-size: 12px;
                    }
                }
            }
        }
    }
}
</style>
